export const kordisMeta = [
  { label: 'Role', value: 'PM + Lead Design' },
  { label: 'Surface', value: 'Web chat app' },
  { label: 'Stage', value: '0 to 1, in build' },
  { label: 'Team', value: 'Eng + design, 4 people' },
];

export const kordisAnswer = [
  { text: 'Gross margin fell from 42% to 36% in March', cite: 1 },
  { text: '. Most of the drop came from freight, which rose 31% after the carrier contract renewed', cite: 2 },
  { text: '. Discounts on the spring promotion account for the rest', cite: 3 },
  { text: '.' },
];

export const kordisSources = [
  { id: 1, title: 'P&L by month', origin: 'QuickBooks', freshness: 'Synced 2h ago' },
  { id: 2, title: 'Carrier contract renewal.pdf', origin: 'Google Drive', freshness: 'Uploaded Mar 3' },
  { id: 3, title: 'Promotions tracker', origin: 'Google Sheets', freshness: 'Synced yesterday' },
];

export const kordisInteractionModel = [
  {
    title: 'Inline citations',
    body: 'Numbered chips in the answer open a sources panel, so every figure can be checked.',
  },
  {
    title: 'Confidence in words',
    body: 'High, Moderate or Low. Plain labels instead of scores nobody can interpret.',
  },
  {
    title: "Ask, don't guess",
    body: 'When a question is ambiguous, Kordis asks a clarifying question instead of inventing an answer.',
  },
  {
    title: 'Stop and start',
    body: 'A state machine for interruptions, so a partial answer never looks finished.',
  },
];

export const kordisTrustPatterns = [
  { title: 'Citations open the source', body: 'Every figure links to the document and page it came from.' },
  { title: 'Confidence in plain words', body: 'The label says why, not just how sure.' },
  { title: 'Asks before guessing', body: 'Ambiguous requests get a question with quick options.' },
];
